import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: "Do I need to know anything about AI to take this course?",
      answer: "Nope. This course is beginner-friendly and walks you through everything step-by-step, even if you've never used an AI tool before."
    },
    {
      question: "What makes this different from all the free YouTube tutorials?",
      answer: "Most free content is outdated, shallow, or sponsored by tools that don't work. This course shows you exactly how to use the best tools in real-world creator workflows."
    },
    {
      question: "How Long Will It Take Me To Complete The Entire Course?",
      answer: "Luckily - you have options! Remember, you get lifetime access to the course so you can go at whatever pace you find best! We find that most people either:\n\n1. Binger (1-2 Days): If you're like me and you prefer to binge great content like watching a great Netflix series... Then you can knock the entire course out in 1-2 days but make sure you aren't skipping the practice exercises to develop real skills!\n\n2. Slow & Steady: If you prefer to take your time and learn at a slower pace, work through a lesson or two a day, along with the practice exercises. It will take you about a week to complete the course at this rate."
    },
    {
      question: "Will I need expensive software or gear?",
      answer: "Nope. Most of the tools we teach are free or extremely affordable, and AI helps you create pro-level content even with minimal equipment."
    },
    {
      question: "Is this course only for YouTubers?",
      answer: "Not at all. While YouTube is a focus, the strategies also apply to short-form content (Reels, TikToks, Shorts), podcasts, business marketing content, and more."
    },
    {
      question: "What is Apprenticeship-Online Learning?",
      answer: "We believe there is a better way to learn online.\n\nMost online courses are surface-level. Instructors speak in abstract language about their process. Or, instructors guide you through overly simplified tutorials that don't match the real world. As a result, these courses can often feel shallow or disappointing.\n\nOur courses are different. We are pioneering a new way to learn online called Apprenticeship-Online Learning.\n\nIn this approach, you learn like an apprentice, watching experts do what they do best. Your instructor brings you into their behind-the-scenes creative process from start to finish, explaining everything they are doing and thinking along the way.\n\nYou get to (virtually) sit next to them in their studio and see everything -- every idea, decision, setback, tool, and technique -- out in the open, for real. All recorded as high-quality, on-demand video, allowing you to apprentice with the world's best anytime, anywhere.\n\nApprenticeship (working and learning alongside an expert) has always been the best way to learn. It just hasn't been accessible to most people, until now."
    },
    {
      question: "Can I Take This Course From Anywhere?",
      answer: "Yes, the course is completely online so you can take the course from anywhere using any device. Learn from the comfort of your own home or take your course with you on the go."
    },
    {
      question: "Do I Get Lifetime Access To The Course?",
      answer: "How does lifetime access sound?\n\nAfter enrolling you have unlimited access to this program for as long as you like. You can go at your own pace.\n\nIf you purchased the course but forgot your login info, simply message @ver_rnv on Telegram and we'll be happy to help you!"
    }
  ];

  return (
    <section id="faq" className="bg-gray-900 text-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mx-auto mb-12">
          <h3 className="text-3xl md:text-4xl font-bold">
            <span>Frequently Asked Questions</span>
          </h3>
        </div>

        <div className="max-w-5xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-gray-900 border-b border-gray-700">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between py-6 text-left cursor-pointer hover:opacity-80 transition-opacity"
              >
                <h5 className="text-lg font-semibold pr-8">{faq.question}</h5>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="pb-6">
                  <div className="text-base text-gray-300 leading-relaxed whitespace-pre-line">
                    {faq.answer}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
